import axios from 'axios';
import { useEffect, useState } from 'react';
import { baseUrl_ } from '../../utils/constants';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import {
  useDiable2faMutation,
  useEnable2faMutation,
} from '../../features/2FAenable/2FAenableSlice';
import customToast, { ToastType } from '../../components_/Toast';

const ToggleSwitch = ({ is2faEnabled }: any) => {
  //   const stored2faEnabled = localStorage.getItem('2fa-enabled');
  //   const initialIsToggled = stored2faEnabled
  //     ? JSON.parse(stored2faEnabled)
  //     : JSON.parse(is2faEnabled);
  const [isToggled, setIsToggled] = useState<boolean>(is2faEnabled);
  const token: string | null = localStorage.getItem('login-token');
  const navigate = useNavigate();

  //   console.log(is2faEnabled, isToggled);

  const refreshPage = () => {
    navigate('/settings/security');
  };

  const handleToggle = () => {
    setIsToggled(!isToggled);
    if (!isToggled) {
      //   console.log(is2faEnabled);
      active2Fa();
    } else {
      //   console.log(is2faEnabled);

      disabled2fa();
    }
  };

  const [enable2fa, { isLoading: isUpdating }] = useEnable2faMutation();
  const [diable2fa, { isLoading: isDisabling }] = useDiable2faMutation();

  const active2Fa = async () => {
    try {
      await enable2fa({ token });
      customToast('2FA successfully enabled.', ToastType.success);
      localStorage.setItem('2fa-enabled', JSON.stringify(!isToggled)); // Update localStorage
    } catch (err) {
      //   console.error('Error enabling 2FA:', err);
      customToast('Failed to enable 2FA', ToastType.error);
    } finally {
      refreshPage();
    }
  };

  const disabled2fa = async () => {
    try {
      await diable2fa({ token });
      customToast('2FA successfully disabled.', ToastType.success);
      localStorage.setItem('2fa-enabled', JSON.stringify(!isToggled)); // Update localStorage
    } catch (err) {
      //   console.error('Error disabling 2FA:', err);
      customToast('Failed to disable 2FA', ToastType.error);
    } finally {
      refreshPage();
    }
  };

  useEffect(() => {
    localStorage.setItem('2fa-enabled', JSON.stringify(isToggled));
  }, [isToggled]);

  return (
    <div className={`toggle-switch ${isDisabling || isUpdating ? 'disabled' : ''}`}>
      <label className='switch'>
        <input
          type='checkbox'
          disabled={isDisabling || isUpdating}
          checked={isToggled}
          onChange={handleToggle}
        />
        <span className='slider round'></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
